import React from 'react';
import styled, { css } from 'styled-components';
import Image from 'next/image';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, textSize } from '@styles';

export const Cards = ({ cards }) => {
  const getProneLink = (phone) => {
    if (phone[0] === '+') {
      return '+' + phone.slice(1).replace(/\D/g, '');
    }
    return phone.replace(/\D/g, '');
  };

  const checkURL = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'http://' + url;
    }
    return url;
  };

  const locationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
<path d="M7.53632 19.895L7.53547 19.8943C6.59592 19.1226 5.71188 18.2869 4.8898 17.3915C2.97956 15.3018 0.991943 12.3595 0.991943 9.11514C0.991943 8.0635 1.19908 7.02215 1.60153 6.05056C2.00397 5.07896 2.59385 4.19615 3.33748 3.45253C4.0811 2.7089 4.96391 2.11903 5.93551 1.71658C6.9071 1.31413 7.94845 1.10699 9.00009 1.10699C10.0517 1.10699 11.0931 1.31413 12.0647 1.71658C13.0363 2.11903 13.9191 2.7089 14.6627 3.45253C15.4063 4.19615 15.9962 5.07896 16.3987 6.05056C16.8011 7.02215 17.0082 8.0635 17.0082 9.11514C17.0082 12.3595 15.0206 15.3027 13.1105 17.3914C12.2884 18.2864 11.4046 19.1225 10.4654 19.8937C10.0065 20.2673 9.53455 20.6245 9.05039 20.9646C9.02191 20.9847 8.98229 20.9856 8.95101 20.9636C8.46312 20.6203 7.99053 20.2698 7.53632 19.895ZM6.47403 11.6412C7.14399 12.3112 8.05263 12.6875 9.00009 12.6875C9.94755 12.6875 10.8562 12.3112 11.5262 11.6412C12.1961 10.9712 12.5725 10.0626 12.5725 9.11514C12.5725 8.16769 12.1961 7.25904 11.5262 6.58908C10.8562 5.91913 9.94755 5.54276 9.00009 5.54276C8.05264 5.54276 7.14399 5.91913 6.47403 6.58908C5.80408 7.25904 5.4277 8.16769 5.4277 9.11514C5.4277 10.0626 5.80408 10.9712 6.47403 11.6412Z" stroke="currentColor" stroke-linejoin="round"/>
</svg>`;

  const siteIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<g clip-path="url(#clip0_14222_107696)">
<path d="M5.48966 18.0104L17.5105 5.98959M17.5105 5.98959H5.48966M17.5105 5.98959V18.0104" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_14222_107696">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`;

  const emailIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
<rect x="0.47619" y="0.97619" width="19.0476" height="14.0476" rx="1.52381" stroke="currentColor" stroke-width="0.952381" stroke-linejoin="round"/>
<path d="M1 1.5L10 8.5L19 1.5" stroke="currentColor" stroke-linejoin="round"/>
</svg>`;

  const phoneIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M18.3453 14.7664L18.0409 15.1631L18.041 15.1631L18.0412 15.1633L18.0422 15.1641L18.0463 15.1673L18.0623 15.1795L18.1228 15.226L18.3392 15.3921L18.9973 15.8978C19.2372 16.0823 19.4776 16.2673 19.6594 16.4076C19.7503 16.4778 19.8263 16.5366 19.88 16.5783L19.9409 16.6258C20.6907 17.3947 20.6747 18.6156 19.9627 19.3276L19.9504 19.3399L19.939 19.353L19.1591 20.2497C18.3475 21.0548 17.2464 21.5 16.0577 21.5C13.2302 21.5 9.83615 19.6032 7.11754 16.886C4.39895 14.1688 2.5 10.7753 2.5 7.94439V7.93648C2.5 6.75029 2.94365 5.64913 3.78897 4.805L4.60707 4.09608L4.62055 4.0844L4.63316 4.07179C5.38971 3.31536 6.61128 3.30945 7.37509 4.05406L7.4226 4.1149C7.46438 4.16863 7.52311 4.24454 7.59333 4.3355C7.73368 4.51729 7.91873 4.75765 8.10321 4.99749L8.60899 5.65549L8.77515 5.87181L8.82165 5.93236L8.83389 5.9483L8.83702 5.95239L8.83781 5.95342L8.83801 5.95368L8.83806 5.95374L9.23467 5.64928L8.83808 5.95376L8.85539 5.97632L8.87516 5.99676C9.59812 6.74476 9.59812 7.94107 8.87516 8.68906L8.8583 8.7065L8.84322 8.72548L8.18814 9.54986C7.91281 9.89634 7.84339 10.3778 8.0428 10.793C9.18727 13.1754 10.8883 14.8887 13.2076 15.9746C13.6225 16.1689 14.0992 16.0949 14.441 15.821L15.2702 15.1566L15.2874 15.1428L15.3034 15.1275C16.0511 14.4113 17.2433 14.4093 18.0009 15.129L18.02 15.1471L18.0409 15.1631L18.3453 14.7664ZM7.36352 4.03946L7.36375 4.03975C7.35838 4.03337 7.35729 4.03172 7.36352 4.03946ZM19.9555 16.6374C19.9632 16.6436 19.9616 16.6425 19.9552 16.6372L19.9555 16.6374Z" stroke="currentColor"/>
</svg>`;

  return (
    <Container>
      {cards.map((item, index) => (
        <Card key={item.alias} id={item.alias} isHasLogo={item.form_data.logo}>
          {item.form_data.logo && (
            <Link type={'site'} href={item.form_data.site ? `${checkURL(item.form_data.site)}` : ''} target="_blank">
              <Image
                src={item.form_data.logo}
                alt={`${item.form_data.name} — партнер Планоплана`}
                objectFit="contain"
                objectPosition="left"
                loading={index < 4 ? 'eager' : 'lazy'}
                height={36}
                width={300}
              />
            </Link>
          )}
          <Header>{item.form_data.name}</Header>
          <Tag>{item.form_data.type}</Tag>
          <Line type={'phone'} href={`tel:${getProneLink(item.form_data.tel)}`}>
            <Icon dangerouslySetInnerHTML={{ __html: phoneIcon }} />
            <Info>{item.form_data.tel}</Info>
          </Line>
          {item.form_data.email && (
            <Line type={'email'} href={`mailto:${item.form_data.email}`}>
              <Icon dangerouslySetInnerHTML={{ __html: emailIcon }} />
              <Info>{item.form_data.email}</Info>
            </Line>
          )}
          {item.form_data.site && (
            <Line type={'site'} href={`${checkURL(item.form_data.site)}`} target="_blank">
              <Icon dangerouslySetInnerHTML={{ __html: siteIcon }} />
              <Info>{item.form_data.site}</Info>
            </Line>
          )}
          <Line type={'location'}>
            <Icon dangerouslySetInnerHTML={{ __html: locationIcon }} />
            <Info>{item.form_data.address}</Info>
          </Line>
        </Card>
      ))}
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin: 0 auto 80px;

  @media ${Points.tablet_portrait} {
    display: grid;
    grid-template-columns: 312px 312px;
    width: fit-content;
    align-items: stretch;
  }

  @media ${Points.tablet_landscape} {
    grid-template-columns: 312px 312px 312px;
  }

  @media ${Points.laptop_wide} {
    grid-template-columns: 305px 305px 305px 305px;
    gap: 20px;
    margin-bottom: 120px;
  }

  @media ${Points.fullhd} {
    grid-template-columns: 330px 330px 330px 330px;
    margin-bottom: 162px;
  }
`;

const Card = styled.article`
  width: 312px;
  border: 1px solid ${Colors.dark_200};
  padding: ${(p) => (p.isHasLogo ? `20px 30px 30px` : `25px 30px 30px`)};

  &:hover {
    border: 1px solid ${Colors.blue_300};
  }

  @media ${Points.laptop_wide} {
    width: 100%;
  }

  img {
    height: 36px !important;
    width: auto !important;
    aspect-ratio: auto;
  }
`;

const Header = styled.h2`
  ${textSize('card_header')};
  font-weight: 300;
  margin-bottom: 15px;
`;

const Tag = styled.div`
  width: fit-content;
  padding: 5px 10px 6px;
  margin-bottom: 25px;
  color: ${Colors.blue_900};
  background-color: ${Colors.blue_200};
  border-radius: 20px;
  ${textSize('description_2')};

  @media ${Points.fullhd} {
    margin-bottom: 30px;
  }
`;

const Line = styled(({ type, ...props }) => (type === 'location' ? <div {...props} /> : <a {...props} />))`
  display: flex;
  gap: 10px;
  margin-top: ${(p) => (p.type === 'location' ? '20px' : '10px')};
  ${textSize('body')};
  color: ${Colors.main_gray};
  text-decoration: none;

  @media ${Points.fullhd} {
    margin-top: ${(p) => (p.type === 'location' ? '25px' : '10px')};
  }

  ${(p) =>
    p.type !== 'location' &&
    css`
      &:hover {
        color: ${Colors.main_blue};
      }
    `}

  ${(p) =>
    p.type === 'location' &&
    css`
      svg {
        width: 17px;
        height: 21px;
      }
    `}

    ${(p) =>
      p.type === 'email' &&
      css`
        svg {
          height: 15px;
        }
      `}
  }

  
`;

const Icon = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Info = styled.span`
  text-decoration: none;
  color: inherit;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
`;

const Link = styled.a``;
